<template lang="pug">
.manage-webhooks-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(data, index) in data' v-slot:[`card-${index}`]='{}')
      .mb-1.text-overflow-ellipse(style='width: 90%')
      .mb-1 
        span.text.me-2 {{ $t('manageWebhooksCardTable.url') }}: {{ data.url }}
      .mb-1
        span.text.me-2 {{ $t('manageWebhooksCardTable.secret') }}: {{ data.secret }}
      td.action.text-end.mt-2
        .text-end.d-flex
          button(
            :title='$t("manageWebhooksCardTable.showWebhookEvents")'
            @click.stop='openShowEventsWebhook(data)'
          )
            icon(name='users')
          button(
            :title='$t("manageWebhooksCardTable.editWebhook")'
            @click.stop='openEditWebhookModal(data)'
          )
            icon(name='pen-to-square')
    template(v-slot:table-head)
      th(style='width: 50%') 
        span.text {{ $t('manageWebhooksCardTable.url') }}
      th(style='width: 40%') 
        span.text {{ $t('manageWebhooksCardTable.secret') }}
      th(style='width: 10%')
        // Coluna de ícones 
    template(v-for='(data, index) in data' v-slot:[`table-row-${index}`]='{}')
      td
        span.text {{ data.url }}
      td
        span.text {{ data.secret }}
        span.ms-2
          a(
            style='cursor: pointer'
            v-clipboard:copy='data.secret'
            v-clipboard:success='onCopy'
          )
            icon(
              name='copy'
              v-tooltip:bottom='$t("manageWebhooksCardTable.copy")'
            )
      td.action.pb-1.text-end
        .text-end.d-flex
          button(
            :title='$t("manageWebhooksCardTable.showWebhookEvents")'
            @click.stop='openShowEventsWebhook(data)'
          )
            icon(name='users')
          button(
            :title='$t("manageWebhooksCardTable.editWebhook")'
            @click.stop='openEditWebhookModal(data)'
          )
            icon(name='pen-to-square')
  edit-webhook-modal#edit-webhook-modal(
    :initial-url='this.selectedWebhook.url'
    :uuid='this.selectedWebhook.uuid'
    @refresh='listWebhooks'
    ref='editWebhookModal'
  )
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import IconStatus from '@/ui/atoms/IconStatus.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
// eslint-disable-next-line max-len
import alert from '@/modules/account/common/alert';
import EditWebhookModal from '@/modules/account/components/organisms/modals/EditWebhookModal.vue';

export default {
  name: 'ManageWebhooksCardTable',
  components: {
    Icon,
    IconStatus,
    CardTable,
    EditWebhookModal,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedWebhook: {},
    };
  },
  methods: {
    openEditWebhookModal(data) {
      this.selectedWebhook = data;
      this.$refs.editWebhookModal.$refs.modal.open();
    },
    openShowEventsWebhook(data) {
      this.selectedWebhook = data;
      this.$router.push({
        name: 'account.developer.webhookevents',
        params: { webhookId: data.uuid },
        query: { webhook: data.url },
      });
    },
    listWebhooks() {
      this.$emit('listWebhooks');
    },
    onCopy() {
      alert.fireAlert(this.$t('manageWebhooksCardTable.secretCopied'), {
        classes: 'alert-success',
        styles:
          'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
        icon: 'circle-check',
      });
    },
  },
};
</script>
<style lang="stylus">
.manage-applications-card-table__name
  max-width: 180px;
@media (min-width: 576px)
  .manage-applications-card-table__name
    max-width: 180px
@media (min-width: 768px)
  .manage-applications-card-table__name
    max-width: 180px
@media (min-width: 992px)
  .manage-applications-card-table__name
    max-width: 500px
@media (min-width: 1200px)
  .manage-applications-card-table__name
    max-width: 470px
@media (min-width: 1400px)
  .manage-applications-card-table__name
    max-width: 640px
</style>
